import { render, staticRenderFns } from "./SiatRiepilogoPraticheListComponent.vue?vue&type=template&id=f1d289ea&scoped=true"
import script from "./SiatRiepilogoPraticheListComponent.vue?vue&type=script&lang=js"
export * from "./SiatRiepilogoPraticheListComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatRiepilogoPraticheListComponent.vue?vue&type=style&index=0&id=f1d289ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d289ea",
  null
  
)

export default component.exports